import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Impressum from '../views/Pages/Impressum.vue'
import Datenschutz from '../views/Pages/Datenschutz.vue'
import Gewinnspiel from '../views/Pages/Gewinnspiel.vue'
import Livestream from '../views/Pages/Livestream.vue'

Vue.use(VueRouter)

const routes = [

   {
      path: '/',
      name: 'home',
      component: Home
   },
   {
      path: '/impressum',
      name: 'impressum',
      component: Impressum,
   },
   {
      path: '/datenschutz',
      name: 'datenschutz',
      component: Datenschutz,
   },
   // {
   //    path: '/gewinnspiel',
   //    name: 'gewinnspiel',
   //    component: Gewinnspiel,
   // },
   // {
   //    path: '/livestream',
   //    name: 'livestream',
   //    component: Livestream,
   // },
   {
      path: '*',
      redirect: '/',
   }
   
]

const router = new VueRouter({
   mode: 'history',
   base: process.env.BASE_URL,
   routes
})

export default router
